<template>
    <div class="navigation-services">
        <div class="navigation__loader" v-if="loading || error">
            <LoadingIndicator />
        </div>
        <template v-if="!loading && !error">
            <div class="navigation-services__filters">
                <div class="page-subnavigation">
                    <div class="page-subnavigation__container">
                        <div class="page-subnavigation__items-wrapper">
                            <div class="page-subnavigation__items">
                                <a v-for="service in services" :key="service.title" v-on:click="toggleService(service)"
                                    :class="{
                                        active:
                                            activeService && activeService.title === service.title,
                                    }" class="page-subnavigation__item">{{ service.title }}</a>
                            </div>
                            <div class="page-subnavigation__gradient-overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navigation-services__filters" v-if="['Practices', 'Regions'].includes(activeService.title)">
                <div class="page-subnavigation">
                    <div class="page-subnavigation__container">
                        <div class="page-subnavigation__items-wrapper">
                            <div class="page-subnavigation__items">
                                <template v-for="service in activeService.services" :key="service.title">
                                    <a :href="service.url" @mouseenter="
                                        toggleChildHover(service)
                                        " @click.prevent="
        activeService.title !== 'Regions'
            ? navigateToService(activeChild, service)
            : null
        " :class="{
        active: activeChild && activeChild.title === service.title,
        'no-pointer':
            activeService && activeService.title === 'Regions',
    }" class="page-subnavigation__item">
                                        {{ service.title }}
                                    </a>
                                </template>
                            </div>
                            <div class="page-subnavigation__gradient-overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navigation-services__results" v-if="slicedChildren && slicedChildren.length > 0">
                <div class="navigation-services__children">
                    <div class="navigation-services__children-inner" v-for="(split, index) in slicedChildren" :key="index">
                        <template v-for="(child, i) in split" :key="i">
                            <a :href="child.url" class="navigation-services__child-link">
                                {{ child.title }} <span class="locations-card__translations" style="margin-left: 8px"
                                    v-if="child.hasCulture">{{
                                        child.translationsAvailableLabel }}
                                </span>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
    components: {
        LoadingIndicator,
    },
    data() {
        return {
            error: false,
            loading: true,
            services: [],
            activeService: null,
            activeChild: null,
            hoverCount: 0,
        };
    },
    mounted() {
        this.getServices();
    },
    computed: {
        slicedChildren() {
            let response = [];

            if (this.activeService && this.activeChild) {
                this.activeChild.children
                    .sort((a, b) => (a.title > b.title ? 1 : b.title < a.title ? -1 : 0))
                    .forEach((child) => {
                        response.push(child);
                        if (child.children) {
                            child.children
                                .sort((a, b) =>
                                    a.title > b.title ? 1 : b.title < a.title ? -1 : 0
                                )
                                .forEach((child) => {
                                    response.push(child);
                                });
                        }
                    });
            }

            if (this.activeService && !this.activeChild) {
                this.activeService.services
                    .sort((a, b) => (a.title > b.title ? 1 : b.title < a.title ? -1 : 0))
                    .forEach((child) => {
                        response.push(child);
                        if (child.children) {
                            child.children
                                .sort((a, b) =>
                                    a.title > b.title ? 1 : b.title < a.title ? -1 : 0
                                )
                                .forEach((child) => {
                                    response.push(child);
                                });
                        }
                    });
            }

            let sorted = response.sort((a, b) => a.title > b.title);

            let chunked = [];
            for (let i = 3; i > 0; i--) {
                chunked.push(sorted.splice(0, Math.ceil(sorted.length / i)));
            }

            return chunked;
        },

        isTouchEnabled() {
            let touchEnabled = ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
            console.log("touchEnabled", touchEnabled)
            return touchEnabled;
        },
    },
    methods: {
        navigateToService: function (child, service) {
            if (this.isTouchEnabled) {
                if (child.id === service.id) {
                    window.location.href = service.url;
                } else {
                    this.activeChild = service;
                }
            } else {
                window.location.href = service.url;
            }
        },

        toggleService: function (service) {
            this.activeService = service;

            if (["Practices", "Regions"].includes(this.activeService.title)) {
                this.activeChild = this.activeService.services[0];
            } else {
                this.activeChild = null;
            }
        },
        toggleChildHover: function (service) {
            this.hoverCount++;
            console.log("navigationHoverFired", this.hoverCount)
            console.log("touchEnabled", this.isTouchEnabled)
            this.activeChild = service;
        },
        toggleChild: function (service) {
            this.activeChild = service;
        },
        getServices: function () {
            axios
                .post("/api/services?culture=en", null, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    this.services = response.data.categories;
                    this.activeService = this.services[0];

                    if (["Practices", "Regions"].includes(this.activeService.title)) {
                        this.activeChild = this.activeService.services[0];
                    }

                    this.loading = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        },
    },
};
</script>
